"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHead = void 0;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _tableHeadRow = require("./tableHeadRow");

var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor, _descriptor2, _descriptor3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function transColumns2TableHeadRowConfigs(columns) {
  var lines = [[]];

  var transOneLine = function transOneLine(columns, lineIndex) {
    if (!lines[lineIndex]) {
      // 所有列最后一行 rowspan + 1
      lines.forEach(function (line) {
        return line.forEach(function (item) {
          return !item.hasChildren && item.rowspan++;
        });
      });
      lines[lineIndex] = [];
    }

    var tempLine = [];
    columns.forEach(function (col) {
      var _col$children;

      if (col.children && !col.title) {
        tempLine.push.apply(tempLine, (0, _toConsumableArray2.default)(transOneLine(col.children, lineIndex)));
        return;
      }

      var children = (_col$children = col.children) !== null && _col$children !== void 0 && _col$children.length ? transOneLine(col.children, lineIndex + 1) : [];
      var colspan = children.length && children.map(function (child) {
        return child.colspan;
      }).reduce(function (sum, num) {
        return sum + num;
      }) || 1;
      var item = {
        key: col.key || col.dataIndex,
        title: col.title,
        rowspan: children.length ? 1 : lines.length - lineIndex,
        colspan: colspan,
        hasChildren: !!children.length,
        ellipsis: !!col.ellipsis,
        width: col.width
      };
      tempLine.push(item);
      lines[lineIndex].push(item);
    });
    return tempLine;
  };

  transOneLine(columns, 0);
  return lines;
}

var TableHead = (_dec = (0, _vuePropertyDecorator.Component)({
  components: {
    TableHeadRow: _tableHeadRow.TableHeadRow
  }
}), _dec2 = (0, _vuePropertyDecorator.Inject)(), _dec3 = (0, _vuePropertyDecorator.Prop)(), _dec4 = (0, _vuePropertyDecorator.Prop)(), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(TableHead, _Vue);

  var _super = _createSuper(TableHead);

  function TableHead() {
    var _this;

    (0, _classCallCheck2.default)(this, TableHead);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "table", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "columns", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "fixed", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TableHead, [{
    key: "rowsConfigs",
    get: function get() {
      return transColumns2TableHeadRowConfigs(this.columns);
    }
  }, {
    key: "rowHeight",
    get: function get() {
      var fixed = this.fixed,
          table = this.table;
      var height = fixed ? table.tableStore.fixedColumnsHeadRowsHeight[0] : undefined;

      if (height && this.rowsConfigs.length && typeof height === 'number') {
        height = "".concat(height / this.rowsConfigs.length, "px");
      }

      return height;
    }
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var rowHeight = this.rowHeight;
      var rows = this.rowsConfigs.map(function (row, i) {
        return h("table-head-row", {
          "key": i,
          "attrs": {
            "rowConfigs": row
          },
          "style": {
            height: rowHeight
          }
        });
      });
      return h("thead", {
        "class": "ant-table-thead"
      }, [rows]);
    }
  }]);
  return TableHead;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "table", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "columns", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "fixed", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.TableHead = TableHead;